import FootballState from "../../../../../sports/football/state/football-state";
import { ContinueFragmentSerializer } from "./ContinueFragmentSerializer";

/* Lateral Fragments are serialized as Continue Fragments with an "L" flag instead of "C" */
export class LateralFragmentSerializer extends ContinueFragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.Lateral;
    }

    getAdvanceFlag() {
        return "L";
    }
}
